<template>
  <footer>
  <div class="footer">
    <template v-if="$mq === 'mobile' || $mq === 'tablet'">
      <b-container class="grid">
        <b-row>
          <b-col class="footer_element">
            <img :src="logo" alt="logo" class="logo" />
          </b-col>
        </b-row>
        <div v-if="native === false && $store.state.company.android_app_id" class="col-12 footer_element">
          <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:300px;">
            <a :href="'https://play.google.com/store/apps/details?id=' + $store.state.company.android_app_id" rel="noreferrer" target="_blank" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:16px;line-height:24px;display:inline-flex;">
              <font-awesome-icon style="font-size:24px;color:#C0C0C0;" :icon="['fab', 'android']"/> <div style="margin-bottom:20px;padding:0 15px;">Baixe o App para android</div>
            </a>
          </div>
        </div>
        <div v-if="native === false && $store.state.company.ios_app_id" class="col-12 footer_element">
          <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:300px;">
            <a :href="'https://itunes.apple.com/us/app/' + $store.state.company.ios_app_id" rel="noreferrer" target="_blank" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:16px;line-height:24px;display:inline-flex;">
              <font-awesome-icon style="font-size:24px;color:#C0C0C0;" :icon="['fab', 'apple']"/> <div style="margin-bottom:10px;padding:0 15px;">Baixe o App para IOS</div>
            </a>
          </div>
        </div>
        <!--b-row v-if="$route.name!=='welcome'">
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a href="#/categories/0" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">PRODUTOS</div>
              </a>
            </div>
          </b-col>
        </b-row-->
        <b-row v-if="$route.name!=='welcome' && !this.$store.state.company.market_place && $store.state.activateOffers">
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a href="#/offers" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">ATIVAR OFERTAS</div>
              </a>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="$route.name!=='welcome' && $store.state.company.hasMembership && $store.state.company.hasMembership === true && ($mq === 'mobile' || $mq === 'tablet')">
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a href="#/membership_prizes" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">CLUBE DE BENEFÍCIOS</div>
              </a>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="$route.name!=='welcome' && $store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST'">
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a :href="'#/company_list/' + $store.state.lastLatLongUri" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">HOME LOJAS</div>
              </a>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="$route.name!=='welcome'">
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a href="#/ongoing" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">PEDIDOS EM ANDAMENTO</div>
              </a>
            </div>
          </b-col>
        </b-row>

        <b-row v-if="$route.name!=='welcome'">
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a href="#/history" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">HISTÓRICO DE COMPRAS</div>
              </a>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="footer_element">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:200px;">
              <a href="#/map" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">ÁREA DE ENTREGA</div>
              </a>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="footer_element">
            <div style="margin:10px auto;width:200px;">
              <a href="#/contact" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;">
                <div style="margin-bottom:20px;">CONTATO</div>
              </a>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:100%;">
            </div>
          </b-col>
        </b-row>
        <b-row v-if="$store.state.company.social_networks && $store.state.company.social_networks.length">
          <b-col cols="12" class="footer_element" style="height:40px;">
            Redes sociais
          </b-col>
          <b-col cols="12" class="footer_element" style="width:100%;overflow-x:auto;overflow-y:hidden;height:36px;">
            <div v-for="(rede, idx) in $store.state.company.social_networks" v-bind:key="idx" style="margin:5px 5px;display:inline;text-align:center;">
              <a v-if="rede.url && rede.url !== '/'" :href="rede.url" target="_blank" :aria-label="rede.name" rel="noopener" style="text-decoration:none; color:#ffffff!important;">
                <font-awesome-icon style="font-size:24px;color:#C0C0C0;" :icon="['fab', getIconRede(rede)]"/>
              </a>
            </div>
          </b-col>
          <b-col cols="12">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:100%;">
            </div>
          </b-col>
        </b-row>
        <b-row v-if="getChoicedCompany().active_anvisa === 'true'" >
          <b-col cols="12" class="footer_element">
            A {{getChoicedCompany().companyBrand}}  segue as determinações da <img src="https://cdnimages.opa4.store/img/fixedimg/farma/anvisa.png" alt="anvisa" style="margin-left:12px;" />
          </b-col>
          <b-col cols="12">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:100%;">
            </div>
          </b-col>
        </b-row>
        <b-row v-if="$store.state.company.card_flags && $store.state.company.card_flags.length">
          <b-col cols="12" class="footer_element" style="height:40px;">
            Aceitamos os cartões
          </b-col>
          <b-col cols="12" class="footer_element" style="width:100vw;overflow-x:auto;overflow-y:hidden;height:46px;display:inline-flex">
            <div v-for="(card, idx) in $store.state.company.card_flags" v-bind:key="idx" style="height:36px;margin:0 auto;">
              <img :src="$store.state.imgPath2 + card.icon" alt="card" class="cardIcon" style="margin:0 5px;" />
            </div>
          </b-col>
          <b-col cols="12">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:100%;">
            </div>
          </b-col>
        </b-row>
        <b-row v-if="getChoicedCompany().active_anvisa === 'true'" >
          <b-col cols="12" class="footer_element" style="font-size:10px;padding: 0 30px;text-align:justify;" >
            {{getChoicedCompany().normative_anvisa}}
          </b-col>
          <b-col cols="12">
            <div style="border-bottom: 1px solid rgba(255,255,255,0.2);margin:10px auto;width:100%;">
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="footer_opa mb-2 mt-2">
            <a :href="'https://s3.amazonaws.com/cdnopa4/img/img/' + $store.state.company.companyId + '/privacy/termo.pdf'" target="_blank" >TERMOS DE USO</a>  - <a :href="'https://s3.amazonaws.com/cdnopa4/img/img/' + $store.state.company.companyId + '/privacy/privacy.pdf'" target="_blank" >POLÍTICA DE PRIVACIDADE</a>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="footer_opa">
            copyright © 2018 {{$store.state.company.companyBrand}} | feito com ♥ por <a style="color:#ffffff;text-decoration:none;" target="_blank" rel="noreferrer" href="https://opabox.com.br">opabox</a>
          </b-col>
        </b-row>
        <b-row class="col-12 footer_element" style="height:70px;"></b-row>
      </b-container>
    </template>




    <!-- desktop -->
    <template v-else>
      <b-container class="grid mb-4">
        <b-row>
          <b-col class="footer_element">
            <img :src="logo" alt="logo" class="logo" />
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-4 mb-3" >
          <!--b-col class="footer_column_link" v-if="$route.name!=='welcome'">
            <a href="#/categories/0">PRODUTOS</a>
          </b-col-->

          <b-col class="footer_column_link" v-if="$route.name!=='welcome' && !this.$store.state.company.market_place && $store.state.activateOffers">
            <a href="#/offers">ATIVAR OFERTAS</a>
          </b-col>

          <!-- b-col class="footer_column_link" v-if="$route.name!=='welcome' && $store.state.company.hasMembership && $store.state.company.hasMembership === true" >
            <a href="#/membership_prizes">CLUBE DE BENEFÍCIOS</a>
          </b-col -->

          <b-col class="footer_column_link" v-if="$route.name!=='welcome' && $store.state.company.block_address_navigation && $store.state.company.block_address_navigation === 'YES_LIST'" >
            <a :href="'#/company_list/' + $store.state.lastLatLongUri">HOME LOJAS</a>
          </b-col>

          <b-col class="footer_column_link" v-if="$route.name!=='welcome'">
            <a href="#/ongoing">PEDIDOS EM ANDAMENTO</a>
          </b-col>

          <b-col class="footer_column_link" v-if="$route.name!=='welcome'">
            <a href="#/history">HISTÓRICO DE COMPRAS</a>
          </b-col>

          <b-col class="footer_column_link">
            <a href="#/map">ÁREA DE ENTREGA</a>
          </b-col>

          <b-col class="footer_column_link" >
            <a href="#/contact">CONTATO</a>
          </b-col>

        </b-row>

        <template v-if="getChoicedCompany().active_anvisa === 'true'">
          <b-row class="mt-4 mb-4">
            <b-col style="border-bottom: 1px solid rgba(255,255,255,0.2);height:20px;"></b-col>
          </b-row>
          <b-row>
            <b-col class="footer_opa text-center">
              A {{getChoicedCompany().companyBrand}}  segue as determinações da <img src="https://cdnimages.opa4.store/img/fixedimg/farma/anvisa.png" alt="anvisa" style="margin-left:12px;" />
            </b-col>
          </b-row>
        </template>

        <b-row class="mt-3 mb-3">
          <b-col style="border-bottom: 1px solid rgba(255,255,255,0.2);height:20px;"></b-col>
        </b-row>

        <b-row class="mt-4 mb-3" align-h="center">
          <b-col v-if="native === false && ( $store.state.company.android_app_id || $store.state.company.ios_app_id)">
            <b-row>
              <b-col class="text-center">BAIXE O APP</b-col>
            </b-row>
            <b-row class="mt-3" align-h="center">
              <b-col cols="5" class="text-center" v-if="$store.state.company.android_app_id" align-v="center">
                <a :href="'https://play.google.com/store/apps/details?id=' + $store.state.company.android_app_id" rel="noreferrer" target="_blank" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:16px;">
                  <font-awesome-icon style="font-size:24px;color:#C0C0C0;" :icon="['fab', 'android']"/> android
                </a>
              </b-col>
              <b-col cols="5" class="text-center" v-if="$store.state.company.ios_app_id">
                <a :href="'https://itunes.apple.com/us/app/' + $store.state.company.ios_app_id" rel="noreferrer" target="_blank" style="text-decoration:none;color:#ffffff!important;font-weight:500;font-size:16px;">
                  <font-awesome-icon style="font-size:24px;color:#C0C0C0;" :icon="['fab', 'apple']"/> ios
                </a>
              </b-col>
            </b-row>
          </b-col>

          <b-col >
            <b-row>
              <b-col class="text-center">ACEITAMOS OS CARTÕES</b-col>
            </b-row>
            <b-row >
              <b-col cols="1" class="text-center mt-3" v-for="(card, idx) in $store.state.company.card_flags" v-bind:key="idx">
                <img :src="$store.state.imgPath2 + card.icon" alt="card" style="height:20px;"/>
              </b-col>
            </b-row>
          </b-col>

          <b-col >
            <b-row>
              <b-col class="text-center">REDES SOCIAIS</b-col>
            </b-row>
            <b-row align-h="center" class="mt-3">
              <template v-for="(rede, idx) in $store.state.company.social_networks" >
                <b-col cols="2" v-bind:key="idx" v-if="rede.url && rede.url !== '/'">
                <a :href="rede.url" target="_blank" :aria-label="rede.name" rel="noopener" style="text-decoration:none; color:#ffffff!important;">
                  <font-awesome-icon style="font-size:24px;color:#C0C0C0;" :icon="['fab', getIconRede(rede)]"/>
                </a>
                </b-col>
              </template>
            </b-row>
          </b-col>

        </b-row>

        <template v-if="getChoicedCompany().active_anvisa === 'true'">
          <b-row class="mt-4 mb-4">
            <b-col style="border-bottom: 1px solid rgba(255,255,255,0.2);height:20px;"></b-col>
          </b-row>
          <b-row>
            <b-col class="footer_opa text-center" style="font-size:10px;padding: 0 8px;text-align:justify!important;">
              {{getChoicedCompany().normative_anvisa}}
            </b-col>
          </b-row>
        </template>

        <b-row class="mt-4 mb-3">
          <b-col style="border-bottom: 1px solid rgba(255,255,255,0.2);height:20px;"></b-col>
        </b-row>
        <b-row>
          <b-col cols="12 mb-2 mt-2" class="footer_opa text-center" >
            <a :href="'https://s3.amazonaws.com/cdnopa4/img/img/' + $store.state.company.companyId + '/privacy/termo.pdf'" target="_blank" >TERMOS DE USO</a> - <a :href="'https://s3.amazonaws.com/cdnopa4/img/img/' + $store.state.company.companyId + '/privacy/privacy.pdf'" target="_blank" >POLÍTICA DE PRIVACIDADE</a>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="footer_opa text-center">
            copyright © 2018 {{$store.state.company.companyBrand}} | feito com ♥ por <a style="color:#ffffff;text-decoration:none;" target="_blank" rel="noreferrer" href="https://opabox.com.br">opabox</a>
          </b-col>
        </b-row>

      </b-container>
    </template>
  </div>
  
  </footer>
</template>

<script>
/* global NATIVE */
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',

  props: ['showProductsLink'],

  data () {
    return {
      native: NATIVE
    }
  },

  computed: {
    logo () {
      if (!this.$store.getters.getLogo) {
        return null
      } else if (!this.$store.state.company.logo_footer) {
        return this.$store.getters.getLogo
      } else {
        return this.$store.state.company.logo_footer
      }
    }
  },

  created () {
    console.log(this.$route)
  },

  methods: {

    ...mapGetters([ 'getChoicedCompany' ]),

    getIconRede (r) {
      return r.icon
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/_variables.scss";

.footer {
  width: calc( 100vw);
  // max-width:1330px;
  min-height:100px;
  background-color: #2C2A29;
  color: #ffffff;
  padding:15px;
}

.footer_element {
  text-align: center;

  .logo {
    mix-blend-mode: screen;
    -webkit-filter: grayscale(100%) contrast(100%);
    filter: grayscale(100%) contrast(100%);
    opacity: 1;
    max-width:150px;
    margin-top:20px;
    margin-bottom:20px;
    @media screen and (max-width: $mobile) {
      max-width:130px;
    }
  }
}

.cardIcon {
  mix-blend-mode: screen;
  // -webkit-filter: grayscale(100%) contrast(100%);
  // filter: grayscale(100%) contrast(100%);
  opacity: 1;
}

.footer_opa {
  text-align: center;
  font-size:12px;
  a {
    color:#ffffff!important;
    text-decoration:underline;
  }
  a:visited {
    color:#ffffff!important;
    text-decoration:underline;
  }
}

.footer_column_link {
  text-align:center;
  border-right: 1px solid rgba(255,255,255,0.2);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 40px;
  height:40px;

  a {
    text-decoration:none;color:#ffffff!important;font-weight:500;font-size:14px;
  }
}

.footer_column_link:last-of-type {
  border-right:0px;
}

</style>
